import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'zipCode' })
export class ZipCodePipe implements PipeTransform {

    public transform(value: string) {
        if (null != value) {
            value = value.trim();

            if (value.length > 5) {
                return value.substring(0, 5) + '-' + value.substring(5);
            }
        }

        return value;
    }
}
